import { NgModule } from '@angular/core';

import { ModalDirective } from './core-modal.directive';
import { ModalContainer } from './modal-container.component';
import { ActiveModal } from './models/active.modal';
import { CoreModalService } from './services/core-modal.service';

@NgModule({
  declarations: [ModalContainer, ModalDirective],
  providers: [CoreModalService, ActiveModal],
  exports: [ModalContainer],
})
export class CoreModalModule {}
